// extracted by mini-css-extract-plugin
export var deleteModal = "_pu-0";